/**
 * The Bench: what the packing station needs, in the order it is needed, with nothing on it
 * about money.
 *
 * Three cards. Vial labels first because it is why the page exists; reprints and the
 * address fix below, both reusing the Orders feature's calls.
 */
import { ChangeAddress } from './ChangeAddress';
import { ReprintDocuments } from './ReprintDocuments';
import { VialLabels } from './VialLabels';
import './bench.css';

export function BenchPage() {
  return (
    <div className="bench-page">
      <VialLabels />
      <div className="bench-page__pair">
        <ReprintDocuments />
        <ChangeAddress />
      </div>
    </div>
  );
}
